<template>
  <div class="mine">
    <div class="top">
      <div class="title">
        <div class="name">
          <div class="padding"></div>
          个人资料
        </div>
      </div>
      <div class="content">
        <div class="left">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
          >
            <el-form-item label="昵称" prop="name">
              <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入昵称"
              ></el-input>
            </el-form-item>
            <el-form-item prop="region" label="行政区划">
              <el-cascader
                  :props="props"
                  v-model="ruleForm.region"
                  :options="regionList"
                  placeholder="请选择行政区划"
                  style="width: 100%"
                  @change="addressChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
              <el-input
                  type="textarea"
                  v-model="ruleForm.address"
                  placeholder="详细地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input
                  v-model="ruleForm.phone"
                  placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            <el-form-item label="高低压类型" prop="type">
              <el-select v-model="ruleForm.type" placeholder="请选择高低压类型">
                <el-option
                    v-for="(item, index) in type"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
              <span style="color: red"
              >*请选择您是高压电工还是低压电工，不同类型合适不同订单（低压电工只能接到低压类型的订单，高压则是都可以）。</span
              >
            </el-form-item>
            <el-form-item label="接单价格" prop="price">
              <el-input
                  v-model="ruleForm.price"
                  placeholder="请输入接单价格"
              ></el-input>
              <span style="color: red"
              >*此价格为接单价格，根据对方用工时间来总结。</span
              >
            </el-form-item>
            <el-form-item label="服务介绍" prop="description">
              <el-input
                  type="textarea"
                  v-model="ruleForm.description"
                  placeholder="谈一下你的技能或者经验,让客户很好的认识你~"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')"
              >保存</el-button
              >
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="right">
          <div class="upload">
            <el-upload
                class="avatar-uploader"
                :multiple="false"
                :action="$uploadFileUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                accept="image/jpeg,image/png"
            >
              <div class="image-area">
                <div  v-if="imageFile">
                  <img :src="$imgUrl + imageFile" class="avatar" />
                  <span>修改头像</span>
                </div>
                <div v-else>
                  <img :src="require('../../assets/image/photo.jpg')" class="avatar" />
                  <span>修改头像</span>
                </div>
              </div>
            </el-upload>
          </div>
          <div class="score-box">
            <div class="score">
              <span v-if="score == 0">{{ "暂无评分" }}</span>
              <el-rate
                  v-if="score != 0"
                  v-model="score"
                  disabled
                  show-score
                  text-color="#ff9900"
                  score-template="{value}"
              />
            </div>
            <div class="desc" v-if="score != 0">历史评分</div>
          </div>
        </div>
      </div>
    </div>
    <div class="btm">
      <div class="title">
        <div class="name">
          <div class="padding"></div>
          资质认证
        </div>
      </div>
      <div class="box">
        <div class="item">
          <div class="key">身份认证</div>
          <div class="value">完成实名认证，享受更多服务</div>
          <div style="float: right">
            <el-button
                type="primary"
                plain
                size="mini"
                @click="dialogTableVisible = true"
            >实名</el-button
            >
          </div>
        </div>
        <div class="item">
          <div class="key">资质认证</div>
          <div class="value">认证营业资质，开启商家服务</div>
          <div style="float: right">
            <el-button
                type="primary"
                plain
                size="mini"
                @click="dialogTableVisible1 = true"
            >实名</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        title="身份证信息"
        :visible.sync="dialogTableVisible"
        width="30%"
    >
      <div class="uploadCss" style="height: 200px">
        <el-col :span="12">
          <el-upload
              class="avatar-uploader"
              :action="$uploadUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess1"
              :multiple="false"
              :before-upload="beforeAvatarUpload"
          >
            <div class="image-area" v-if="ruleForm.identityCard">
              <img :src="$imgUrl + ruleForm.identityCard" class="avatar" />
              <span>更换</span>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
        <el-col :span="12">
          <el-upload
              class="avatar-uploader"
              :action="$uploadUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess2"
              :multiple="false"
              :before-upload="beforeAvatarUpload"
          >
            <div class="image-area" v-if="ruleForm.identityCardOr">
              <img :src="$imgUrl + ruleForm.identityCardOr" class="avatar" />
              <span>更换</span>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
      </div>
      <el-button size="mini" type="primary" @click="submitForm('ruleForm')"
      >保存</el-button
      >
    </el-dialog>
    <el-dialog title="资质信息" :visible.sync="dialogTableVisible1" width="30%">
      <div class="uploadCss" style="height: 200px">
        <el-col :span="12">
          <el-upload
              class="avatar-uploader"
              :action="$uploadUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess3"
              :multiple="false"
              :before-upload="beforeAvatarUpload"
          >
            <div class="image-area" v-if="ruleForm.tradingCertificate">
              <img
                  :src="$imgUrl + ruleForm.tradingCertificate"
                  class="avatar"
              />
              <span>更换</span>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
      </div>
      <el-button size="mini" type="primary" @click="submitForm('ruleForm')"
      >保存</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import api from "../../http/electrician/api.js";
import serverConfig from "../../http/config";
import {
  factory_userinfo,
  factory_info_update,
  electrician_info_password,
  ProvinceList,
  equOrderList,
  equOrderListS,
  equOrderListSs,
} from "../../http/factory/add-eme.js";
export default {
  name: "mine",
  data() {
    return {
      dialogTableVisible: false,
      dialogTableVisible1: false,
      ruleForm: {
        name: "",
        address: "",
        phone: "",
        type: "",
        price: "",
        description: "",
        identityCard: "",
        identityCardOr: "",
        tradingCertificate: "",
        region: [],
        province: "",
        city: "",
        county: "",
      },
      type: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入地址",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择高低压类型",
            trigger: "change",
          },
        ],
        description: [
          {
            required: true,
            message: "请填写公司简介",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入接单价格",
            trigger: "blur",
          },
        ],
      },
      uploadUrl: "",
      imageUrl: "",
      imageFile: "",
      score: 0,
      regionList: [],
      props: {
        label: "label",
        value: "id",
      },
      datas: {},
    };
  },

  methods: {
    addressChange(value) {
      console.log(value);
      this.ruleForm.province = value[0];
      this.ruleForm.city = value[1];
      this.ruleForm.county = value[2];
    },
    getRegion() {
      ProvinceList().then((data) => {
        this.regionList = data;
      });
    },
    handleAvatarSuccess1(file) {
      this.ruleForm.identityCard = file.fileName;
    },
    handleAvatarSuccess2(file) {
      this.ruleForm.identityCardOr = file.fileName;
    },
    handleAvatarSuccess3(file) {
      this.ruleForm.tradingCertificate = file.fileName;
    },
    handleAvatarSuccess(res) {
      if (res.code == 200) {
        this.imageFile = res.fileName;
        this.imageUrl = res.url;
      }
    },
    beforeAvatarUpload(file) {
      const isCheck = ["image/jpeg", "image/png"].indexOf(file.type) >= 0;
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isCheck) {
        this.$message.error("上传头像图片只能是 JPG/JPEG/JFIF/PNG 格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isCheck && isLt5M;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveInfo();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    saveInfo() {
      api
          .electrician_info_update({
            name: this.ruleForm.name,
            address: this.ruleForm.address,
            phone: this.ruleForm.phone,
            electricianTypeId: this.ruleForm.type,
            price: this.ruleForm.price,
            introduce: this.ruleForm.description,
            heading: this.imageFile,
            identityCard: this.ruleForm.identityCard,
            identityCardOr: this.ruleForm.identityCardOr,
            tradingCertificate: this.ruleForm.tradingCertificate,
            province: this.ruleForm.province,
            city: this.ruleForm.city,
            county: this.ruleForm.county,
          })
          .then((res) => {
            this.$message({
              message: "修改信息成功",
              type: "success",
            });
          });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    fetchUserInfo() {
      api.electrician_userinfo({}).then((res) => {
        this.ruleForm = {
          name: res.name,
          address: res.address == null ? "" : res.address,
          phone: res.phone,
          type: res.electricianTypeId,
          price: res.price,
          description: res.introduce,
          identityCard: res.identityCard,
          region: [
            parseInt(res.province),
            parseInt(res.city),
            parseInt(res.county),
          ],
          identityCardOr: res.identityCardOr,
          tradingCertificate: res.tradingCertificate,
        };
        this.imageUrl = serverConfig.baseURL + res.heading;
        this.imageFile = res.heading;
        this.score = res.fraction;
      });
    },
    fetchElectricianType() {
      api.electrician_type({}).then((res) => {
        this.type = res;
      });
    },
  },
  created: function() {
    this.uploadUrl = serverConfig.baseURL + "/api/base/upload";
    this.getRegion();
  },
  mounted: function() {
    //模板编译/挂载之后
    this.fetchUserInfo();
    this.fetchElectricianType();
  },
};
</script>

<style lang="less" scoped="scoped">
.uploadCss {
  .avatar-uploader-icon[data-v-266d29ce] {
    border: 1px dashed #d9d9d9;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}

.mine {
  width: 100%;
}

.title {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid @vue-border-color;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  .name {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .padding {
    width: 4px;
    height: 16px;
    background: #ff5252;
    margin-right: @vue-spacing-row-sm;
  }
}

.top {
  width: 100%;
  background: @vue-bg-color;
  padding: 0px @vue-spacing-row-sm;
  box-sizing: border-box;

  .content {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .left {
      width: calc(100% - 300px);
      padding-top: @vue-spacing-col-lg;
      box-sizing: border-box;

      .el-input,
      .el-select,
      .el-textarea {
        width: 100%;
      }
    }

    .right {
      width: 300px;
      padding-top: @vue-spacing-col-lg;
      box-sizing: border-box;

      .upload,
      .score {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 10px;
      }

      .avatar-uploader .el-upload {
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
        border: 1px dashed #d9d9d9;
        border-radius: @vue-border-radius-circle;
      }

      .avatar-uploader-icon:hover {
        border-color: #409eff;
      }

      .image-area {
        width: 150px;
        height: 150px;
        position: relative;
        border-radius: @vue-border-radius-circle;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }

        span {
          width: 100%;
          height: 30px;
          position: absolute;
          left: 0px;
          bottom: 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: @vue-font-size-sm - 2;
          color: @vue-text-color-inverse;
          background: @vue-bg-color-mask;
        }
      }

      .personal-score {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 24px;
          height: 24px;
          margin-right: 4px;
        }

        span {
          font-size: @vue-font-size-base;
          color: @vue-text-color-red;
          padding: 5px 10px;
          box-sizing: border-box;
          border-radius: @vue-border-radius-base;
          line-height: 20px;
        }
      }
    }
  }
}

.btm {
  width: 100%;
  margin-top: @vue-spacing-col-lg;
  padding: 0px @vue-spacing-row-sm @vue-spacing-col-lg @vue-spacing-row-sm;
  box-sizing: border-box;
  background: @vue-bg-color;

  .box {
    width: 100%;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item {
      width: 48%;
      height: 120px;
      background: @vue-bg-color-grey;
      padding: @vue-spacing-col-lg @vue-spacing-row-lg;
      box-sizing: border-box;

      .key,
      .value {
        width: 100%;
        height: 40%;
        display: flex;
        align-items: center;
      }

      .key {
        font-size: @vue-font-size-sm + 4;
        font-weight: bold;
      }

      .value {
        font-size: @vue-font-size-sm - 2;
        color: @vue-text-color-grey;
      }
    }
  }
}

.score-box {
  margin-top: 20px;

  .score {
    font-size: 15px;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 0.15rem;
      height: 0.15rem;
      margin-right: 0.06rem;
    }

    .num {
      padding-left: 0.1rem;
      color: #ff7e36;
      font-size: 0.13rem;
    }
  }

  .desc {
    color: #6c6c6c;
    font-size: 0.12rem;
    margin-top: 10px;
    text-align: center;
  }
}
</style>
